import { useEffect, useRef, useState } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Box from "../../layout/boxes/Box/Box";
import {
	StyledMenu,
	StyledNavigation,
	StyledNavigationContainer,
} from "./HamburgerMenu.styles";
import {
	HamburgerMenuProps,
	HamburgerMenuSubComponents,
} from "./HamburgerMenu.types";
import React from "react";
import HamburgerButton from "./HamburgerButton";
import HamburgerMenuItem from "./HamburgerMenuItem/HamburgerMenuItem";

const INVALID_CHILD_ERROR_MESSAGE =
	"Invalid HamburgerMenu subcomponent: The child you provided is not a valid HamburgerMenu subcomponent, please provide HamburgerMenu.Item subcomponent";

const HamburgerMenu: React.FC<HamburgerMenuProps> &
	HamburgerMenuSubComponents = ({
	className,
	isVisible,
	children,
}: HamburgerMenuProps) => {
	const block = new BemIt("HamburgerMenu");

	const menuRef = useRef<HTMLUListElement>(null);
	const [menuHeight, setMenuHeight] = useState(0);

	useEffect(() => {
		const node = menuRef.current;
		if (node) {
			if (menuHeight !== node.scrollHeight) setMenuHeight(node.scrollHeight);
		}
	}, [menuHeight]);

	const menuClassName = addClass(className).after(
		block.mod(isVisible ? "expand" : "")
	);

	const navigationContainerClassName = block
		.el("nav-container")
		.mod(isVisible ? "expand" : "").out;

	const menuItems = React.Children.map(children, (child, index) => {
		if (React.isValidElement(child)) {
			const isItem = child.type === HamburgerMenu.Item;

			if (!isItem) {
				console.error(INVALID_CHILD_ERROR_MESSAGE);
				return null;
			}

			return (
				React.isValidElement(child) &&
				React.cloneElement(child as React.ReactElement, {
					isVisible,
				})
			);
		}
	});

	return (
		<StyledMenu className={menuClassName}>
			<Box position="relative" height="100vh">
				<StyledNavigationContainer className={navigationContainerClassName}>
					<StyledNavigation
						ref={menuRef}
						position="absolute"
						top={`calc(50% - ${menuHeight}px / 1.5)`}
						left="50%"
					>
						{menuItems}
					</StyledNavigation>
				</StyledNavigationContainer>
			</Box>
		</StyledMenu>
	);
};

HamburgerMenu.Button = HamburgerButton;
HamburgerMenu.Item = HamburgerMenuItem;

export default HamburgerMenu;
